<template>
  <div class="content">
    <div class="container-fluid">
      <div class="d-flex justify-content-center p-4">
        <card class="col-sm-8 col-xl-6">
          <!-- <h3 slot="header" class="card-title">Efetuar Login</h3> -->
          <div class="row">
            <div class="col-12 text-center mb-4">
              <h4>Login - WebDraft</h4>
            </div>
          </div>
          <form>
            <div class="row">
              <div class="col-md-12">
                <base-input
                  type="text"
                  label="Usuário"
                  placeholder="Usuário"
                  v-model="user.username"
                ></base-input>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <base-input type="password" label="Senha" placeholder="Senha" v-model="user.password"></base-input>
              </div>
            </div>

            <div class="text-center col-12">
              <button type="submit" class="btn btn-fill btn-info w-50" @click.prevent="login">Entrar</button>
            </div>
            <div class="clearfix"></div>
          </form>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "src/components/Cards/Card";

export default {
  components: {
    Card
  },
  methods: {
    login() {
      var url = this.$urlApi + "/api/login";
      this.axios.post(url, this.user).then(res => {
        let data = res.data;
        if (data.status) {
          console.log("Login efetuado com Sucesso!");
          sessionStorage.setItem("loginInfo", JSON.stringify(data));
          this.redirectAfter();
        } else {
          alert(data.msg);
          sessionStorage.removeItem("loginInfo");
        }
      });
    },
    redirectAfter() {
      this.$router.push("/webdraft/processos");
    },
    checkLoginStatus($json) {
      let checkLoginStatus = JSON.parse(sessionStorage.getItem("loginInfo"));

      if (checkLoginStatus != null || checkLoginStatus != undefined) {
        if (
          checkLoginStatus.hasOwnProperty("status") &&
          checkLoginStatus.status
        ) {
          this.redirectAfter();
        }
      }
    }
  },
  mounted() {
    this.checkLoginStatus();
  },
  data() {
    return {
      name: "LoginWebDraft",
      user: {
        username: "",
        password: "",
        email: ""
      }
    };
  }
};
</script>

<style >

</style>
